import * as yup from 'yup';

export const EMAIL_INPUT_ID = 'EMAIL_INPUT_ID';

export const emailValidationSchema = yup.object().shape({
  EMAIL_INPUT_ID: yup
    .string()
    .email('Invalid email format')
    .required('This field is required'),
});
